import React from 'react'
import logo from './logos/calendly.png'

function CalendlyLogo({
  className
}) {
  return (
    <div className={className}>
      <img src={logo} alt="Calendly Logo"/>
    </div>
    )
  }

export default CalendlyLogo
